import React from 'react';
import { Drawer, Button, Space } from 'antd';

const CustomDrawer = ({
    open,
    onClose,
    onSubmit,
    title = 'Drawer Title',
    width = 480,
    children,
    showFooter = true,
    submitText = 'Submit',
    cancelText = 'Cancel',
    loading = false,
    closeIcon = false
}) => {
    return (
        <Drawer
            title={title}
            placement="right"
            onClose={onClose}
            open={open}
            width={width}
            closeIcon={closeIcon}
            styles={{
                body: {
                    padding: '14px 24px',
                },
                content: {
                    height: '100vh',
                },
                wrapper: {
                    minHeight: '100vh',
                },
            }}
            destroyOnClose
            footer={
                showFooter && (
                    <Space style={{ float: 'right' }}>
                        <Button onClick={onClose}>{cancelText}</Button>
                        <Button type="primary" onClick={onSubmit} loading={loading}>
                            {submitText}
                        </Button>
                    </Space>
                )
            }
        >
            {children}
        </Drawer>
    );
};

export default CustomDrawer;
